import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { H2 } from '@liveauctioneers/hammer-ui-core/text';
import React from 'react';
import isEqual from 'react-fast-compare';
import styled from 'styled-components';

import { RatingDisplay } from '@/components/RatingDisplay/RatingDisplay';

type Props = {
    completedReview: any;
};

const ReviewedPageRatings = (props: Props) => {
    const { completedReview } = props;
    return (
        <section>
            <StyledReviewField>
                <RatingHeader>
                    <FormattedMessage id="review_page.fields.accuracy" />
                </RatingHeader>
                <RatingDisplay rating={completedReview.accuracy} />
            </StyledReviewField>
            <StyledReviewField>
                <RatingHeader>
                    <FormattedMessage id="review_page.fields.responsiveness" />
                </RatingHeader>
                <RatingDisplay rating={completedReview.responsiveness} />
            </StyledReviewField>
            <StyledReviewField>
                <RatingHeader>
                    <FormattedMessage id="review_page.fields.payment" />
                </RatingHeader>
                <RatingDisplay rating={completedReview.payment} />
            </StyledReviewField>
            <StyledReviewField>
                <RatingHeader>
                    <FormattedMessage id="review_page.fields.shipping" />
                </RatingHeader>
                <RatingDisplay rating={completedReview.shipping} />
            </StyledReviewField>
            <StyledReviewField>
                <RatingHeader>
                    <FormattedMessage id="review_page.fields.overall" />
                </RatingHeader>
                <RatingDisplay rating={completedReview.overall} />
            </StyledReviewField>
        </section>
    );
};

export default React.memo<Props>(ReviewedPageRatings, isEqual);

const RatingHeader = styled(H2)`
    margin-bottom: 4px;
`;

const StyledReviewField = styled.div`
    margin-bottom: 40px;
    max-width: 580px;
`;
